<template>
  <div class="main">
    <div class="box">
      <div class="header">
        安全管理>应急物资    
      </div>
      <div class="table">
        <div class="table-top">
          <div class="grid-search">
              <!-- <el-date-picker
                  v-model="search.date"
                  align="right"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                  style="margin-right:1vw;"
                  @change="doFilter"
              ></el-date-picker> -->
              <el-input v-model="search.name" style="width:200px" placeholder="请输入物资名称" clearable @change="doFilter">
                <el-button slot="append" icon="el-icon-search"></el-button>
              </el-input>
            </div>
            <button class="addwuzi" @click="addPlan">添加物资</button>
        </div>
        <div class="title">
          <div class="item">序号</div>
          <div class="item">名称</div>
          <div class="item">数量</div>
          <div class="item">位置</div>
          <div class="item">时间</div>
          <div class="item">使用记录</div>
        </div>
        <div class="scroll">
          <div class="content-i" v-for="(item,index) in listData" :key="index">
          <div class="text">{{item.index}}</div>
          <div class="text">{{item.name}}</div>
          <div class="text">{{item.count}}</div>
          <div class="text">{{item.place}}</div>
          <div class="text">{{item.createDate}}</div>
          <div class="text btn">
            <div class="btn-l" @click="updateFun(item)">编辑</div>
            <div class="btn-r" @click="sumbitInfo(item)">查看</div>
          </div>
        </div>
        </div>
        <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[5, 10, 20, 50]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalItems"
            ></el-pagination>
        <el-dialog width="500px" title="添加物资" :visible.sync="modifyVisible" append-to-body>
              <el-form
                :model="workerInfo"
                ref="workerInfo"
                label-width="160px"
                label-position="right"
                :rules="rules"
              >
                <el-form-item label="名称：" prop="name">
                  <el-input v-model="workerInfo.name" autocomplete="off" style="width:220px;"></el-input>
                </el-form-item>
                <el-form-item label="数量：" prop="count">
                  <el-input v-model="workerInfo.count" type="number" autocomplete="off" style="width:220px;"></el-input>
                </el-form-item>
                <el-form-item label="位置：">
                  <el-input v-model="workerInfo.place" autocomplete="off" style="width:220px;"></el-input>
                </el-form-item>
                <el-form-item label="备注：">
                  <el-input v-model="workerInfo.remarks" type="textarea" :rows="2" autocomplete="off" style="width:220px;"></el-input>
                </el-form-item>
              </el-form>
              <div slot="footer" class="dialog-footer">
                <el-button @click="modifyVisible = false">取 消</el-button>
                <el-button type="primary" @click="modifyWorkerInfo('workerInfo')">确 定</el-button>
              </div>
            </el-dialog>

            <!-- 展示使用记录 -->
            <el-dialog width="1000px" title="物资使用记录" :visible.sync="hisVis" append-to-body>
              <el-table
                stripe
                :data="listHistory"
                
                style="width: 100%;"
                :header-cell-style="{background:'#EBEBEB',color:'#909399'}"
              >
                <template slot="empty">
                  <p>{{dataText1}}</p>
                </template>
                <el-table-column label="序号"  type="index" width="80"></el-table-column>
                <el-table-column label="名称">
                  <template slot-scope="scope">
                    <span>{{ scope.row.suppliesName}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="数量">
                  <template slot-scope="scope">
                    <span>{{ scope.row.count}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="备注">
                  <template slot-scope="scope">
                    <span>{{ scope.row.remarks}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="使用人">
                  <template slot-scope="scope">
                    <span>{{ scope.row.createName}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="时间" width="240">
                  <template slot-scope="scope">
                    <span>{{ scope.row.createDate }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import myHttp from '../../../untils/port.js'
import util from '../../../untils/util.js'
import base from '../../../untils/base'
export default {
  data() {
    return {
      listData: [
        // {index:'1',id:'1',name:'便携呼吸机',num:'2',around:'仓库',createDate:'2021-07-08'},
        // {index:'2',id:'2',name:'雨衣',num:'5',around:'仓库',createDate:'2021-07-08'},
        // {index:'3',id:'3',name:'绷带',num:'10',around:'仓库',createDate:'2021-07-08'},
        // {index:'4',id:'4',name:'止疼药',num:'10',around:'仓库',createDate:'2021-07-08'},
      ],
      search: {
        //查询
        name:'',
        // name: '',
        // projectId: '',
        // date:util.myTime.getCurTime(),
        // temperatureType:'2',
        // teamsId: '',
        // entId: '',
        // personName: '',
      },
      groupId: '',
      dataText: '数据加载中...',
      
      currentPage: 1,
      pageSize: 10,
      totalItems: 4,
      modifyVisible: false,
      workerInfo: {
        id: '',
        name:'',
        count:0,
        place:'',
        remarks:'',
        createBy:'',
        projectId:''
      },
      rules:{
        name:[
           { required: true, message: '请输入', trigger: 'blur' }
        ],
        count:[
           { required: true, message: '数量不能为空'}
        ]
      },
      //检查事项列表
      napeList:[],
      //责任单位
      entList:[],
      //责任人
      personList:[],
      //使用列表
      listHistory:[],
      dataText1:'数据加载中...',
      hisVis:false,
    }
  },
  created() {
    this.groupId = util.session.get('groupId')
  },
  mounted() {
    // this.search.projectId = this.groupId
    // if (this.search.projectId == '') {
    //   this.$store.commit('setGroupId')
    //   this.search.projectId = this.$store.state.groupId
    // }
    // this.getNapeList()
    // this.getEntList()
    // this.getPerosn()
    this.groupId = util.session.get('groupId')
    this.getData()
  },
  methods: {
    //获取事项
    // getNapeList(){
    //   var that = this
    //   myHttp.selectProQsNapeListByProjectId({
    //     projectId:this.groupId
    //   }).then(function(resp){
    //     console.log(resp)
    //     if(resp.data.code=='200'){
    //       var list = resp.data.data.proQsNapes||[]
    //       that.napeList = list
    //     }
    //   })
    // },
    //责任单位
    // getEntList(){
    //   var that = this
    //   myHttp.getProjectEntByProjectId({
    //       projectId:this.groupId
    //   }).then(function(resp){
    //       if (resp.data.code == '200'){
    //           var list = resp.data.data.projectEnt || []
    //           that.entList = list
    //       }
    //   })
    // },
    //获取人员
    // getPerosn(){
    //   var that = this
    //   myHttp.getRoleUserList({
    //     userType:util.session.get('roleId'),
    //     groupId:this.groupId
    //   }).then(function(resp){
    //     if(resp.data.code=="200"){
    //         var list = resp.data.data.users||[];
    //         that.personList = list;
    //     }
    //   },function(){});
    // },
    //
    handleSizeChange(val) {
        this.pageSize = val
        this.handleCurrentChange(this.currentPage)
    },
    handleCurrentChange(val) {
        this.currentPage = val
        this.currentChangePage()
    },
    // 监控当前页码
    currentChangePage(list) {
        this.getData()
    },
    // 搜索数据
    doFilter(index) {
      this.getData()
    },
    // 获取数据
    getData() {
      var that = this
      this.search.pageSize = this.pageSize
      this.search.pageNum = this.currentPage
      myHttp.selectProEmergencySuppliesPage(this.search).then(
        function(resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.pageInfo.list || []
            for(var i=0;i<list.length;i++){
              list[i].index = (i+1)+(that.currentPage-1)*that.pageSize
            }
            that.listData = list
            if (that.listData.length == 0) {
              that.dataText = '暂无数据'
            }else{
              that.totalItems = resp.data.data.pageInfo.total||0
            }
          } else {
            that.$message.error(resp.data.msg)
            that.dataText = '暂无数据'
          }
        },
        function() {}
      )
    },
    
    //添加计划
    addPlan(){
      this.modifyVisible = true
      this.workerInfo.id = ''
      this.workerInfo.name = ''
      this.workerInfo.count = ''
      this.workerInfo.place = ''
      this.workerInfo.remarks = ''
      this.workerInfo.createBy = ''
      this.workerInfo.projectId = ''
    },
    //编辑
    updateFun(row){
      console.log(row)
      this.modifyVisible = true
      this.workerInfo.id = row.id
      this.workerInfo.name = row.name
      this.workerInfo.count = row.count
      this.workerInfo.place = row.place
      this.workerInfo.remarks = row.remarks
    },
    /**
     * 判断是否展示
     */
    isMenuExit(row){
        var flag = util.common.filterBtnMenu(row)
        return flag
    },
    /**
     * 提交
     */
    modifyWorkerInfo(formName){
      var that = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          that.workerInfo.projectId = this.groupId
          that.workerInfo.createBy = util.session.get('user').id
          if(that.workerInfo.id == ''){
            myHttp.createProEmergencySupplies(that.workerInfo).then(function(resp){
              // console.log(resp)
              if(resp.data.code=='200'){
                that.$message.success('提交成功')
                that.modifyVisible = false
                that.getData()
              }else{
                that.$message.error(resp.data.msg)
              }
            })
          }else{
            that.workerInfo.updateBy = util.session.get('user').id
            myHttp.updateProEmergencySupplies(that.workerInfo).then(function(resp){
              if(resp.data.code=='200'){
                that.$message.success('提交成功')
                that.modifyVisible = false
                that.getData()
              }else{
                that.$message.error(resp.data.msg)
              }
            })
          }
        } else {
          return false
        }
      })
    },
    /**
     * 查看
     */
    sumbitInfo(row){
      // this.$router.push({path:'/planProHis/'+row.id})
      this.hisVis = true
      var that = this
      myHttp.selectProEmergencyProcessingDetailsList({
        suppliesId:row.id,
        projectId:this.groupId
      }).then(function(resp){
        console.log(resp)
        if(resp.data.code=='200'){
          var list = resp.data.data.proEmergencyProcessingDetailss||[]
          that.listHistory = list
          if(list.length==0){
            that.dataText1 = '暂无数据'
          }
        }
      })
    },

  }
}
</script>
<style>
  @import '../../../assets/css/common.css';
</style>
<style scoped>
.main{
  flex: 1;
  background-color: #f6f5f8;
  padding-left:8px ;
  padding-right:24px ;
}
.table{
  height: 83vh;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0vw 0vw 1vw 0vw 
		rgba(105, 159, 204, 0.5);
}
.table::-webkit-scrollbar{
  width: 0;
  height: 0;
}
.scroll{
  height: 66vh;
  overflow: scroll;
}
.scroll::-webkit-scrollbar{
  width: 0;
  height: 0;
}
.table-top{
  min-height: 6vh;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 9px 0 9px;
}
.addwuzi{
  background-color: #0b62f0;
  color: #fff;
  width: 150px;
  height: 4vh;
  font-family: PingFang-SC-Medium;
	font-size: 18px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #ffffff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
.addwuzi:hover{
  opacity: 0.6;
}
.title{
  height: 6vh;
  min-height: 6vh;
  background-color: #dfe1e3;
  display: flex;
  font-family: PingFang-SC-Bold;
	font-size: 22px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #333333;
}
.item, .text{
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
.content-i{
  min-height: 6vh;
  height: 6vh;
  display: flex;
  background-color: #fff;
  border-bottom: 2px solid #e7e7e7;
  font-family: PingFang-SC-Medium;
	font-size: 20px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #666666;
}
.content-i:hover{
  background-color: #e1edf8;
}
.btn{
  display: flex;
  justify-content: center;
  font-family: PingFang-SC-Medium;
	font-size: 20px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0vh;
	color: #2e5be9;
}
.btn>.btn-l{
  margin-right: 5px;
}
.btn>.btn-l:hover{
  cursor: pointer;
  opacity: 0.7;
}
.btn>.btn-r{
  margin-left: 5px;
}
.btn>.btn-r:hover{
  cursor: pointer;
  opacity: 0.7;
}
.header{
  display: flex;
  min-height: 6vh;
  line-height: 6vh;
  font-family: PingFang-SC-Regular;
	font-size: 18px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #000000;
}
.el-pagination{
  background-color: #dfe1e3;
}
</style>